import { PATH_ALERT, PATH_MODEL_CONFIGURATION } from 'home/constants/RouteConstants'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import useActions from 'utils/customHook/useActions'
import useTitle from 'utils/customHook/useTitle'
import SieauParameterDto from '../../dto/SieauParameterDto'
import SearchTable from 'referencial/components/SearchTable'
import CmsAction from 'events/actions/CmsAction'
import { getMiniHour } from 'utils/DateUtil'
import { Icon, Tooltip } from '@mui/material'
import AlertModelStepper from 'alerting/components/map/AlertModelStepper'
import ConfirmModal from 'components/modal/ConfirmModal'
import { sortBy } from 'lodash'
import { componentHasHabilitations } from 'utils/HabilitationUtil'
import { H_SITUATION_MODEL_OPTIONS } from 'account/constants/AccessRulesConstants'
import { push } from '@lagunovsky/redux-react-router'

const headers = ['nullValue', 'nullValue2', 'nullValue3', 'nullValue4', 'categoryId', 'title', 'planification', 'hourGeneration', 'hourPublication']

const AdminModelApp = ({

}) => {
    const {
        cmsModels,
        cmsCategories,
    } = useSelector(store => ({
        cmsModels: store.EventsReducer.cmsModels,
        cmsCategories: store.EventsReducer.cmsCategories,
    }), shallowEqual)

    const [modelToOpen, setModelToOpen] = useState({})
    const [openModel, setOpenModel] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!componentHasHabilitations(H_SITUATION_MODEL_OPTIONS)) { // A modifier quand react-router sera à jour
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(CmsAction.fetchAllCMSModels())
    }, [])

    useTitle(() => [{
        title: i18n.situation,
        href: PATH_ALERT,
    }, {
        title: i18n.modelOptions,
        href: PATH_MODEL_CONFIGURATION,
    }], [])

    useActions(() => ({
        new: () => {
            setModelToOpen({})
            setOpenModel(true)
        },
    }), [])

    const daysOptions = useMemo(() => [
        { value: '*', label: i18n.allDays },
        { value: '1', label: i18n.monday },
        { value: '2', label: i18n.tuesday },
        { value: '3', label: i18n.wednesday, disabled: true },
        { value: '4', label: i18n.thursday },
        { value: '5', label: i18n.friday },
        { value: '6', label: i18n.saturday },
        { value: '0', label: i18n.sunday },
    ], [])

    const dataFormatted = useMemo(() => sortBy(cmsModels, 'modelId').map(model => ({
        ...model,
        nullValue: (
            <Tooltip title={i18n.delete}>
                <Icon
                    onClick={() => {
                        setModelToOpen(model)
                        setOpenDelete(true)
                    }}
                >
                    close
                </Icon>
            </Tooltip>
        ),
        nullValue2: (
            <Tooltip title={i18n.change}>
                <Icon
                    onClick={() => {
                        setModelToOpen(model)
                        setOpenModel(true)
                    }}
                >
                    edit
                </Icon>
            </Tooltip>
        ),
        nullValue3: (
            <Tooltip title={i18n.downloadJson}>
                <Icon onClick={() => dispatch(CmsAction.exportJsonCmsModel(model.modelId))} >
                    download
                </Icon>
            </Tooltip>
        ),
        nullValue4: (
            <Tooltip title={i18n.create}>
                <Icon onClick={() => dispatch(CmsAction.playCmsModel(model.modelId))} sx={{ margin: '5px' }}>
                    play_circle_outline
                </Icon>
            </Tooltip>
        ),
        categoryId: cmsCategories.find(categ => categ.id === model.categoryId)?.title || i18n.unknown,
        planification: daysOptions.find(opt => opt.value === model.planification)?.label || i18n.unknown,
        hourGeneration: getMiniHour(model.hourGeneration),
        hourPublication: getMiniHour(model.hourPublication),
    })), [cmsCategories, cmsModels, daysOptions])

    const onValidate = () => {
        dispatch(CmsAction.deleteCMSModel(modelToOpen.modelId))
        setOpenDelete(false)
        setModelToOpen({})
    }

    return (
        <>
            <SearchTable
                title={i18n.newslettersModels}
                data={dataFormatted}
                headers={headers}
                customHeaders={{
                    categoryId: i18n.category,
                    title: i18n.name,
                    planification: i18n.frequency,
                    hourPublication: i18n.sendingTime,
                }}
                customWidthHeaders={{
                    nullValue: '0%',
                    nullValue2: '0%',
                    nullValue3: '0%',
                    nullValue4: '5%',
                    categoryId: '15%',
                    title: '35%',
                    planification: '15%',
                    hourGeneration: '15%',
                    hourPublication: '15%',
                }}
                margin={0}
            />
            <AlertModelStepper
                modelToOpen={modelToOpen}
                isOpen={openModel}
                setIsOpen={setOpenModel}
            />
            <ConfirmModal
                isOpen={openDelete}
                title={i18n.areYouSureWantDeleteModel}
                subTitle={modelToOpen.title}
                onValidate={onValidate}
                onClose={() => setOpenDelete(false)}
            />
        </>
    )
}

AdminModelApp.propTypes = {
    applicationSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    setTitle: PropTypes.func,
    updateDataTypesByProject: PropTypes.func,
    fetchDataTypesByProject: PropTypes.func,
    push: PropTypes.func,
    updateSieauParameters: PropTypes.func,
}

export default AdminModelApp
